<template>
<div class="chapter">
<div class="inner_page">
<p class="h1l" id="d7e142016">I Will </p>
<table border="0" class="table"><colgroup><col/><col/></colgroup><tbody><tr><td>Listen for God’s direction in the encouraging words of a friend.</td><td>yes</td><td>no</td></tr><tr><td>Trust that God can use my friends to help me grow.</td><td>yes</td><td>no</td></tr><tr><td>Understand that a good friend is a gift from God.</td><td>yes</td><td>no</td></tr><tr><td>Listen to a friend’s words as intently as I would want my friend to listen to me.</td><td>yes</td><td>no</td></tr><tr><td>Know that a friend’s words are usually spoken out of concern.</td><td>yes</td><td>no</td></tr><tr><td>Learn to embrace a friend’s words.</td><td>yes</td><td>no</td></tr><tr><td>Attempt to encourage my friends as often as possible.
</td><td>yes</td><td>no</td></tr></tbody></table><p class="h1l" id="d7e142716">Things to Do </p>
<p class="ul" id="d7e145416"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Pray for wisdom to know how to encourage others.</i></p>
<p class="ul" id="d7e145916"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Write a thank-you note today to one friend who has encouraged you.</i></p>
<p class="ul" id="d7e146516"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Be prepared to offer a few words of encouragement to a friend.</i></p>
<p class="ul" id="d7e147016"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Invite a friend to consult with you on an upcoming decision.</i></p>
<p class="ul" id="d7e147516"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Call a friend to say how much you appreciate his or her friendship.</i></p>
<p class="ul" id="d7e148116"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Read about David and Jonathan’s friendship in 1 Samuel, chapters 19 </i><i>and 20.</i></p>
<p class="ul" id="d7e148916"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Offer your friendship to someone with whom you’d like to have a closer </i><i>relationship.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Inc_9781418557720_epub_c12_r1.vue?fd467f92